import React from 'react';

export const WelcomePinpad = () => {
  return (
    <svg
      width="219"
      height="121"
      viewBox="0 0 219 121"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_503_449)">
        <path
          d="M149.24 23.68L154.44 20.95C160.65 17.69 164.54 11.26 164.54 4.24998V1.34998C164.54 0.71998 165.13 0.24998 165.75 0.39998L217.26 12.76C217.7 12.87 218.01 13.26 218.01 13.71V17.08C218.01 24.09 214.12 30.53 207.91 33.78L202.71 36.51"
          fill="white"
        />
        <path
          d="M149.24 23.68L154.44 20.95C160.65 17.69 164.54 11.26 164.54 4.24998V1.34998C164.54 0.71998 165.13 0.24998 165.75 0.39998L217.26 12.76C217.7 12.87 218.01 13.26 218.01 13.71V17.08C218.01 24.09 214.12 30.53 207.91 33.78L202.71 36.51"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M100.38 107.83L48.56 120.32C46.49 120.82 44.32 120.82 42.25 120.32L1.5 110.55C1.13 110.46 0.870001 110.13 0.870001 109.75V108.06C0.870001 108.06 0.650001 107.71 1.74 107.44C2.83 107.17 42.24 99.37 42.24 99.37L93.7 106.2L100.38 107.83Z"
          fill="#33B8E7"
        />
        <path
          d="M51.3101 95.5L1.22011 107.57C0.740107 107.69 0.740107 108.38 1.22011 108.49L42.2401 118.33C44.3201 118.83 46.4801 118.83 48.5501 118.33L97.2701 106.59"
          fill="#99DCF3"
        />
        <path
          d="M100 108.81V110.04C100 110.38 99.68 110.63 99.35 110.55L41.85 96.76C41.22 96.61 40.78 96.05 40.78 95.41V94.18C40.78 93.84 41.1 93.59 41.43 93.67L98.93 107.46C99.56 107.61 100 108.17 100 108.81Z"
          fill="#5046A5"
        />
        <path
          d="M51.3101 95.5L1.22011 107.57C0.740107 107.69 0.740107 108.38 1.22011 108.49L42.2401 118.33C44.3201 118.83 46.4801 118.83 48.5501 118.33L97.2701 106.59"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M167.23 65.77L89.7501 47.1C88.2001 46.73 86.5701 46.93 85.1701 47.67L83.8901 48.34"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M211.84 42.37L114.14 93.61C112.12 94.67 110.86 96.76 110.86 99.04V120.07"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M110.86 103.32L32.3201 84.49C31.4701 84.28 30.8601 83.52 30.8601 82.64V80.86"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M41.6702 80.48L34.2402 84.37C33.7602 84.62 33.2102 84.69 32.6802 84.56"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M153.99 72.58L89.3901 57.02C88.0701 56.7 86.6801 56.87 85.4801 57.5L46.3501 78.03"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M87.6902 50.2V56.86"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M104.01 43.43L134.74 27.31C136.4 26.44 138.32 26.2 140.14 26.64L199.71 40.94C200.69 41.17 200.85 42.5 199.96 42.96L169.14 59.12C167.48 59.99 165.56 60.23 163.73 59.79L104.25 45.46C103.27 45.22 103.11 43.9 104 43.44L104.01 43.43Z"
          fill="#99DCF3"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M103.93 65.96L98.3901 68.87C97.6601 69.25 96.8201 69.36 96.0201 69.16L82.7301 65.96C82.4101 65.88 82.3601 65.46 82.6501 65.31L88.1901 62.4C88.9201 62.02 89.7601 61.91 90.5601 62.11L103.85 65.31C104.17 65.39 104.22 65.81 103.93 65.96Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M122.89 70.5L117.35 73.41C116.62 73.79 115.78 73.9 114.98 73.7L101.69 70.5C101.37 70.42 101.32 70 101.61 69.85L107.15 66.94C107.88 66.56 108.72 66.45 109.52 66.65L122.81 69.85C123.13 69.93 123.18 70.35 122.89 70.5Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M141.9 75.06L136.36 77.97C135.63 78.35 134.79 78.46 133.99 78.26L120.7 75.06C120.38 74.98 120.33 74.56 120.62 74.41L126.16 71.5C126.89 71.12 127.73 71.01 128.53 71.21L141.82 74.41C142.14 74.49 142.19 74.91 141.9 75.06Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M93.5102 71.41L87.9702 74.32C87.2402 74.7 86.4002 74.81 85.6002 74.61L72.3102 71.41C71.9902 71.33 71.9402 70.91 72.2302 70.76L77.7702 67.85C78.5002 67.47 79.3402 67.36 80.1402 67.56L93.4302 70.76C93.7502 70.84 93.8002 71.26 93.5102 71.41Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M112.46 75.95L106.92 78.86C106.19 79.24 105.35 79.35 104.55 79.15L91.2601 75.95C90.9401 75.87 90.8901 75.45 91.1801 75.3L96.7201 72.39C97.4501 72.01 98.2901 71.9 99.0901 72.1L112.38 75.3C112.7 75.38 112.75 75.8 112.46 75.95Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M131.48 80.51L125.94 83.42C125.21 83.8 124.37 83.91 123.57 83.71L110.28 80.51C109.96 80.43 109.91 80.01 110.2 79.86L115.74 76.95C116.47 76.57 117.31 76.46 118.11 76.66L131.4 79.86C131.72 79.94 131.77 80.36 131.48 80.51Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M83.09 76.86L77.55 79.77C76.82 80.15 75.98 80.26 75.18 80.06L61.89 76.86C61.57 76.78 61.52 76.36 61.81 76.21L67.35 73.3C68.08 72.92 68.92 72.81 69.72 73.01L83.01 76.21C83.33 76.29 83.38 76.71 83.09 76.86Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M102.04 81.4L96.5002 84.31C95.7702 84.69 94.9302 84.8 94.1302 84.6L80.8402 81.4C80.5202 81.32 80.4702 80.9 80.7602 80.75L86.3002 77.84C87.0302 77.46 87.8702 77.35 88.6702 77.55L101.96 80.75C102.28 80.83 102.33 81.25 102.04 81.4Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M121.06 85.96L115.52 88.87C114.79 89.25 113.95 89.36 113.15 89.16L99.8602 85.96C99.5402 85.88 99.4902 85.46 99.7802 85.31L105.32 82.4C106.05 82.02 106.89 81.91 107.69 82.11L120.98 85.31C121.3 85.39 121.35 85.81 121.06 85.96Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M72.6701 82.31L67.1301 85.22C66.4001 85.6 65.5601 85.71 64.7601 85.51L51.4701 82.31C51.1501 82.23 51.1001 81.81 51.3901 81.66L56.9301 78.75C57.6601 78.37 58.5001 78.26 59.3001 78.46L72.5901 81.66C72.9101 81.74 72.9601 82.16 72.6701 82.31Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M91.62 86.85L86.08 89.76C85.35 90.14 84.51 90.25 83.71 90.05L70.42 86.85C70.1 86.77 70.05 86.35 70.34 86.2L75.88 83.29C76.61 82.91 77.45 82.8 78.25 83L91.54 86.2C91.86 86.28 91.91 86.7 91.62 86.85Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M110.64 91.41L105.1 94.32C104.37 94.7 103.53 94.81 102.73 94.61L89.44 91.41C89.12 91.33 89.07 90.91 89.36 90.76L94.9 87.85C95.63 87.47 96.47 87.36 97.27 87.56L110.56 90.76C110.88 90.84 110.93 91.26 110.64 91.41Z"
          fill="#B6B2FA"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M0.860107 108.06V109.75C0.860107 110.13 1.12011 110.46 1.49011 110.55L42.2401 120.32C44.3201 120.82 46.4801 120.82 48.5501 120.32L100.37 107.83"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M71.9701 107.73L64.8501 109.44C64.3901 109.55 63.9101 109.55 63.4501 109.44L61.0701 108.87L68.1901 107.16C68.6501 107.05 69.1301 107.05 69.5901 107.16L71.9701 107.73Z"
          fill="#051F8F"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M60.7401 110.44L53.6201 112.15C53.1601 112.26 52.6801 112.26 52.2201 112.15L49.8401 111.58L56.9601 109.87C57.4201 109.76 57.9001 109.76 58.3601 109.87L60.7401 110.44Z"
          fill="#051F8F"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M79.6401 112.83L108.92 119.85C110.2 120.16 111.53 120.16 112.8 119.85L211.75 96.01C214.63 95.32 216.67 92.74 216.67 89.77V44.22C216.67 41.67 214.92 39.45 212.44 38.85L139.5 21.35C137.68 20.91 135.75 21.15 134.09 22.02L34.1501 74.44C32.1301 75.5 30.8701 77.59 30.8701 79.87V99.84C30.8701 100.03 30.9001 100.22 30.9601 100.39"
          stroke="#051F8F"
          strokeWidth="0.75"
          strokeMiterlimit="10"
        />
        <path
          d="M41.3 93.65C41.3 93.65 41.38 93.65 41.42 93.66L98.92 107.45C99.55 107.6 99.99 108.16 99.99 108.8V110.03C99.99 110.33 99.75 110.56 99.47 110.56C99.43 110.56 99.39 110.56 99.35 110.55L41.85 96.76C41.22 96.61 40.78 96.05 40.78 95.41V94.18C40.78 93.88 41.02 93.65 41.3 93.65ZM41.3 92.65C40.46 92.65 39.78 93.33 39.78 94.18V95.41C39.78 96.52 40.53 97.48 41.62 97.74L99.12 111.53C99.24 111.56 99.36 111.57 99.48 111.57C100.32 111.57 101 110.89 101 110.04V108.81C101 107.7 100.25 106.74 99.16 106.48L41.66 92.69C41.54 92.66 41.42 92.65 41.3 92.65Z"
          fill="#D9D9FB"
        />
        <path
          d="M89.5801 110.43L96.8401 108.69"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M46.86 96.57L40.28 98.15"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M85.78 109.35L92.16 107.81"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeMiterlimit="10"
        />
        <path
          d="M50.7202 95.9L95.7302 106.69L89.5002 108.2L44.4702 97.4L50.7202 95.9Z"
          fill="#66CAED"
        />
        <path
          d="M90.1301 108.56V110.05L99.5401 107.78C99.5401 107.78 99.3101 107.55 98.9301 107.46C98.2901 107.31 96.8101 106.95 96.8101 106.95L90.1301 108.56Z"
          fill="#00A6E0"
        />
        <path
          d="M87.21 108.74L89.5 108.2L44.47 97.4L42.24 97.94L87.21 108.74Z"
          fill="#99DCF3"
        />
        <path
          d="M83.2 105.03L76.08 106.74C75.62 106.85 75.14 106.85 74.68 106.74L72.3 106.17L79.42 104.46C79.88 104.35 80.36 104.35 80.82 104.46L83.2 105.03Z"
          fill="#051F8F"
          stroke="#051F8F"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
        <path
          d="M90.1301 108.56L88.3901 108.98L90.1301 109.44V108.56Z"
          fill="#33B8E7"
        />
        <path
          d="M150.6 50.93C159.823 50.93 167.3 47.2498 167.3 42.71C167.3 38.1702 159.823 34.49 150.6 34.49C141.377 34.49 133.9 38.1702 133.9 42.71C133.9 47.2498 141.377 50.93 150.6 50.93Z"
          fill="#051F8F"
        />
        <path
          d="M144.96 45.1L142.22 40.67L145.66 40.09L148.4 44.52L144.96 45.1Z"
          fill="white"
        />
        <path
          d="M143.73 43.11L159.82 40.37L161.05 42.37L144.96 45.1L143.73 43.11Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_503_449">
          <rect
            width="217.78"
            height="120.95"
            fill="white"
            transform="translate(0.610107)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
